import { render, staticRenderFns } from "./childbusinesses.vue?vue&type=template&id=64568a70"
import script from "./childbusinesses.vue?vue&type=script&lang=js"
export * from "./childbusinesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports